// extracted by mini-css-extract-plugin
module.exports = {"pseudoLink":"TransitionMessage_pseudoLink__fIk5c","leaveReviewLink":"TransitionMessage_leaveReviewLink__2RoOi"};